import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export const ReconciliationPrayer = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card className="p-6 bg-sage-50 mt-8">
      <Button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-sm transition-all duration-200"
      >
        <div className="flex justify-between items-center w-full">
          <h2 className="font-serif text-xl font-semibold">Reconciliation with God</h2>
          {isExpanded ? <ChevronUp className="ml-2" /> : <ChevronDown className="ml-2" />}
        </div>
      </Button>
      
      {isExpanded && (
        <div className="mt-6 animate-fade-in">
          <p className="font-serif text-lg leading-relaxed text-sage-700 bg-white p-6 rounded-lg shadow-sm border border-sage-100 text-center text-justify">
            Father please forgive me of my sins. I accept Jesus Christ as my personal Lord and Saviour. 
            Give me the power to sin no more in Jesus' name, Amen.
          </p>
        </div>
      )}
    </Card>
  );
};